export default {
  data() {
    return {
      // 温度是否过高
      isTooHeight: true,
      // 报警列表
      alertList: []
    };
  },
  props: {
    plotId: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.getWarnInfoList(this.plotId);
  },
  components: {},
  methods: {
    initChart() {},
    // 获取设备报警记录
    async getWarnInfoList(plotId) {
      let params = {
        plotId,
        pageSize: '20',
        pageNum: '1'
      };
      let {
        rows,
        code
      } = await this.$api.getWarnInfoList(params);
      this.alertList = rows;
      console.log(rows, '报警记录');
    }
  }
};